import { useRef, useMemo } from "react";
import SelectPicker from 'rsuite/SelectPicker';
import 'rsuite/SelectPicker/styles/index.css';

/**
 * COMPONENTE PRINCIPAL
 * @param formik
 * @returns {JSX.Element}
 * @constructor
 */
export default function Banco({
  formik,
}){
    /**
     * Contenedor para SelectPicker
     * @type {React.MutableRefObject<null>}
     */
    const bancoRef = useRef(null);
    /**
     * Datos del catálogo : Banco
     */
    const { cajas } = JSON.parse(sessionStorage.getItem('user'));
    /**
     * Solo se guardan las cajas de bancos
     * @type {*[]|[{valor: string, descripcion: string}]}
     */
    const data = useMemo(() => {
        let data = [];
        cajas && cajas.forEach(
            /**
             *
             * @param item.tipo
             * @param item.id_caja
             * @param item.caja
             */
            (item) => {
                if (item.tipo === "B") {
                    data.push({valor: item.id_caja, descripcion: item.caja});
                }
            }
        );
        /**
         * Sí el usuario no tiene cajas disponibles se agrega una sola opción
         */
        if (data.length > 0) {
            return data;
        } else return [{valor: 'noData', descripcion: 'SIN DATOS'}];
    },[cajas]);

    return(
        <>
            <style type={'text/css'}>
                {`
                    #banco{
                        background-color : ${formik.values.forma_pago === 'TE' || formik.values.forma_pago === 'CO' ? "var(--bs-gray-200)!important;" : "var(--bs-gray-100)!important;"}
                        border: 0!important;
                    }
                    
                    #banco > .rs-stack{
                        display : block!important;
                    }                      
                    #banco-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #banco > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #banco-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #banco-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #banco-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>
            <div ref={bancoRef} className={'position-relative'}>
                <SelectPicker
                    container={() => bancoRef.current}
                    label={<div className={'labelSelect ps-2'}>Banco:</div>}
                    data={data}
                    style={{width: "100%"}}
                    menuStyle={{width: "100%"}}
                    menuAutoWidth={false}
                    id={'banco'}
                    name={'banco'}
                    labelKey={'descripcion'}
                    valueKey={'valor'}
                    value={formik.values.id_caja}
                    onChange={(value) => formik.setFieldValue('id_caja', value)}
                    onBlur={formik.handleBlur}
                    searchable={false}
                    cleanable={false}
                    disabledItemValues={["noData"]}
                    readOnly={formik.values.forma_pago === 'TE' || formik.values.forma_pago === 'CO'}
                />
            </div>
        </>
    );
}
